import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { destinations } from '../data/mock';

const DestinationsSection = () => {
  return (
    <section className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
            Explore Paradise
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Discover three of Asia's most captivating coastal regions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {destinations.map((destination) => (
            <Link
              key={destination.id}
              to={`/destinations/${destination.id}`}
              className="group relative h-[500px] rounded-2xl overflow-hidden"
            >
              {/* Background Image */}
              <img
                src={destination.image}
                alt={destination.name}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40 to-transparent" />

              {/* Content */}
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <span className="text-orange-500 text-sm font-medium mb-2">
                  {destination.tagline}
                </span>
                <h3 className="text-3xl font-serif font-bold text-white mb-3">
                  {destination.name}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed mb-4 line-clamp-3">
                  {destination.description}
                </p>
                <div className="flex items-center gap-2 text-orange-500 font-medium group-hover:gap-3 transition-all">
                  Explore Destination
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DestinationsSection;
